export interface Manufacturer {
	id?: number
	name: string
	business_name: string
	email: string
	id_number: number
	phone_number: number
	address: string
	product_id: number
	product?: string
	products: number
	profile?: string // According to swagger
	role_id?: number // According to swagger
	manufacturer?: any // According to swagger
}


export interface FetchManufacturerByIDResponse {
	status: boolean;
	message: string;
	data: Manufacturer;
}

export interface ManufacturerPayload extends Partial<Manufacturer> {
}

export interface ManufacturerItemList {
	name: string;
	business_name: string;
	id_number: string;
	email: string,
	phone_number: string;
	product_id: number;
}
